/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotPen = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotPen"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M63.74 17.29c0-1.25-.5-2.43-1.39-3.31l-6.91-6.82-2.56-2.56a5.4 5.4 0 0 0-.8-.65c-.77-.53-1.68-.83-2.64-.83-.35 0-.68.05-1.01.12a4.9 4.9 0 0 0-2.55 1.36L4.54 45.93l.04 14.25-.05 2.02h2.19l14.13.04 41.33-41.32c.28-.28.52-.6.72-.94.55-.78.85-1.71.85-2.68z"
      />
      <path
        fill="#fff"
        d="m6.55 46.75.03 13.45 13.45.03L60.76 19.5a2.957 2.957 0 0 0 0-4.19l-9.3-9.3a2.957 2.957 0 0 0-4.19 0z"
      />
      <path
        fill="#B7E854"
        d="M57 23.05 43.56 9.79 6.63 46.72s4.91-2.36 9.92 3.3c6.02 6.79 4.08 8.96 3.31 10.12z"
      />
      <path
        fill="#27DBA8"
        d="M60.95 15.41 51.3 5.89a2.66 2.66 0 0 0-3.75.01l-3.99 3.88S55.4 21.59 56.79 23.2l4.17-4.01a2.66 2.66 0 0 0-.01-3.78"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="m61.12 14.96-9.3-9.3a3.46 3.46 0 0 0-4.89 0L6.19 46.4l-.15.15.04 14.15 14.15.04 40.89-40.89a3.44 3.44 0 0 0 1.01-2.45c0-.93-.36-1.79-1.01-2.45zM11.21 55.58c-1.26-1.26-2.86-1.82-4.14-1.6l-.02-6.74c1.69-1.6 5.91-.14 9.27 3.22 1.71 1.71 2.97 3.65 3.54 5.47.53 1.68.41 3.02-.33 3.8l-6.74-.02c.22-1.29-.34-2.88-1.59-4.14zm9.61.05c-.58-1.84-1.8-3.78-3.45-5.51l32.91-32.91 6.03 6.03L21.16 58.4c.09-.81-.02-1.75-.34-2.77m-4.15-6.22c-2.81-2.67-5.98-4.06-8.28-3.79l35.15-35.15 6.03 6.03zm43.74-30.26-3.39 3.39L44.25 9.77l3.39-3.39c.96-.96 2.52-.96 3.48 0l9.3 9.3c.46.46.72 1.08.72 1.74s-.26 1.27-.72 1.74z"
      />
    </svg>
  );
};
export default IllustrationSpotPen;
